import React from 'react';
import { Selection, Pedido } from '../../../../types';
import { formatCurrency } from '../../../../../../../../../utils/functions';
import ClientSelectionRow from '../ClientSelectionRow/ClientSelectionRow';
import './ClientSection.scss';

interface ClientSectionProps {
  clientIndex: number;
  selections: (Selection & { pedido: Pedido })[];
  allowEdit: boolean;
  activeDropdownId: string | null;
  onIncreaseQuantity: (pedido_id: number, selection_id: string) => void;
  onDecreaseQuantity: (pedido_id: number, selection_id: string) => void;
  onDeleteSelection: (pedido_id: number, selection_id: string) => void;
  onSplitSelection?: (pedido_id: number, selection_id: string) => void;
  onToggleDropdown: (dropdownId: string, event: React.MouseEvent) => void;
  onSelectClient: (pedidoId: number, selectionId: string, clientIndex: number) => void;
  numPeople: number;
  formatClientLabel?: (clientIndex: number) => string;
}

const ClientSection: React.FC<ClientSectionProps> = ({
  clientIndex,
  selections,
  allowEdit,
  activeDropdownId,
  onIncreaseQuantity,
  onDecreaseQuantity,
  onDeleteSelection,
  onSplitSelection,
  onToggleDropdown,
  onSelectClient,
  numPeople,
  formatClientLabel
}) => {
  const isGroup = clientIndex === -1;
  
  // Calculate total excluding paid selections (only pending items)
  const clientTotal = selections.reduce((sum, s) => {
    // Skip paid selections from total
    if (s.payed === true) return sum;
    return sum + s.total_price;
  }, 0);

  return (
    <div className="client-section">
      <h4 className="client-header">
        {isGroup ? 'Grupo' : `Comensal ${clientIndex + 1}`}
      </h4>

      <table className="selections-table">
        <tbody>
          {selections.map((sel) => (
            <ClientSelectionRow
              key={`${sel.pedido.pedido_id}-${sel.selection_id}`}
              selection={sel}
              allowEdit={allowEdit}
              activeDropdownId={activeDropdownId}
              onIncreaseQuantity={onIncreaseQuantity}
              onDecreaseQuantity={onDecreaseQuantity}
              onDeleteSelection={onDeleteSelection}
              onSplitSelection={onSplitSelection}
              onToggleDropdown={onToggleDropdown}
              onSelectClient={onSelectClient}
              numPeople={numPeople}
              formatClientLabel={formatClientLabel}
            />
          ))}
        </tbody>
      </table>

      <div className="client-total">
        <span>Total: </span>
        <span> {formatCurrency(clientTotal)}</span>
      </div>
    </div>
  );
};

export default ClientSection;
